import workspaceQuery from '../../../graphql/queries/product/ProductAttributeConfigWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/product/ProductAttributeConfigListQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/ProductAttributeConfigQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/ProductAttributeConfigDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/ProductAttributeConfigMutation.graphql';
import fragment from '../../../graphql/fragments/product/ProductAttributeConfigFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const ProductAttributeConfig: EntityType = {
  type: 'ProductAttributeConfig',
  title: 'Product Attributes',
  formTitle: 'Product Attribute',
  formUrl: '/Products/AttributeConfig/Details/',
  workspaceUrl: '/Products/AttributeConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'PRODUCTS_ATTRIBUTES',
};

export default ProductAttributeConfig;
